import { render, staticRenderFns } from "./NormalSearchNav89.vue?vue&type=template&id=3220c466&scoped=true"
import script from "./NormalSearchNav89.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav89.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220c466",
  null
  
)

export default component.exports